module.exports = __webpack_public_path__ + "static/media/cwrs.50ee9da9.png";